<template>
    <div class="basket-item" v-if="device" :class="[{'delete': deleted, 'card card-body card-body-sm': showCard}]">
        <div class="media">
            <div class="delete-overlay" :class="{'active': deleteControls}">
                <h5>Are you sure you want to remove this device?</h5>
                <div>
                    <button class="btn btn-outline-dark btn-lg btn-rounded" @click="hideDeleteOverlay">Cancel</button>
                    <button class="btn btn-danger btn-lg btn-rounded" @click="processDelete()">Remove</button>
                </div>
            </div>

            <div class="media-left d-none d-md-block" v-if="!hideImage">
                <img :src="device.image_path" alt="Device Image" class="img-2x" />
            </div>
            <div class="media-body">
                <h5>{{ device.title }}</h5>
                <div class="basket-btns cursor-pointer" v-if="!hideControls" @click="showDeleteOverlay">
                    <i class="fal fa-trash-alt text-danger"></i>
                </div>

                <!-- Problems -->
                <div class="price-table table">
                    <div class="pricing-container">
                        <div v-for="problemPricing in problemsPricing" :key="problemPricing.problem.id">
                            <!-- Normal Problem -->
                            <div class="tr">
                                <div class="td">
                                    {{ problemPricing.problem.title }}
                                </div>
                                <div class="td" v-if="!inWarrantyStatus">
                                    <span v-if="!isPromo && problemPricing.price !== 0" :class="{ 'text-line-through text-muted': problemIsInTheSale(problemPricing) }">
                                        <span v-html="currencySymbol"></span>{{ problemPricing.non_sale_price.toFixed(2) }}
                                    </span>
                                    <template v-else>
                                        FREE
                                    </template>
                                </div>
                                <div class="td" v-if="inWarrantyStatus && warrantyRepairChargeable">
                                    FREE
                                </div>
                            </div>
                            <!-- Sale item -->
                            <div class="tr text-danger" v-if="problemIsInTheSale(problemPricing)">
                                <div class="td">
                                    <em>{{ booking.sale_title }}</em>
                                </div>
                                <div class="td">
                                    NOW <span v-html="currencySymbol"></span>{{ problemPricing.price.toFixed(2) }}
                                </div>
                            </div>
                            <!-- Free battery -->
                            <div class="tr" v-if="batteryIsIncluded(problemPricing.problem)">
                                <div class="td">
                                    Battery
                                </div>
                                <div class="td">
                                    FREE
                                </div>
                            </div>
                        </div>
                        <div class="tr" v-if="inWarrantyStatus && warrantyRepairChargeable">
                            <div class="td">
                                Convenience Charge
                            </div>
                            <div class="td">
                                <span v-html="currencySymbol"></span>{{ warrantyRepairCharge }}
                            </div>
                        </div>
                    </div>
                </div>
                <button @click="editDevice()" v-if="!hideControls" class="btn btn-outline-dark btn-rounded btn-sm delete-button" :disabled="retrieving"><i v-if="retrieving" class="fa fa-spinner fa-pulse"></i> Add/remove problems</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        props: {
            deviceData: {
                type: Object,
                default() {
                    return {};
                }
            },
            deviceKey: {
                type: String,
                default: ''
            },
            hideControls: {
                type: Boolean,
                default: false
            },
            hideImage: {
                type: Boolean,
                default: false
            },
            showCard: {
                type: Boolean,
                default: false
            },
            isPromo: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                deleteControls: false,
                deleted: false,
                retrieving: false
            }
        },

        mounted() {
            this.retrieving = false;
        },

        computed: {
            ...mapGetters([
                'booking',
                'inWarrantyStatus',
                'problemIsInTheSale',
                'warrantyRepairChargeable',
                'warrantyRepairCharge',
                'currencySymbol'
            ]),

            device() {
                return this.deviceData.device;
            },

            problemsPricing() {
                return this.deviceData.problems_pricing;
            },

            screenIsSelected() {
                if (!this.deviceData || !this.deviceData.problems) {
                    return false;
                }

                for (let i = 0; i < this.deviceData.problems.length; i++) {
                    if (this.deviceData.problems[i].code === 'screen-replacement') {
                        return true;
                    }
                }
                return false;
            }
        },

        methods: {
            ...mapActions([
                'batteryIsIncluded',
                'deleteDevice',
                'retrieveBooking',
                'retrieveDevice'
            ]),

            /** Determine if a free battery is included with this problem */
            batteryIsIncluded(problem) {
                if (this.inWarrantyStatus || !this.deviceData.device.battery_required_for_screen_repair) {
                    return false;
                }
                return (this.screenIsSelected && problem.code === 'screen-replacement');
            },

            /** Retrieve this device and edit problems */
            editDevice() {
                this.retrieving = true;
                this.retrieveDevice({
                    deviceKey: this.deviceKey,
                    setModelVersionId: true
                }).then(() => {
                    return this.$router.push({name: 'repairSelect'})
                });
            },

            /** Hide the delete controls */
            hideDeleteOverlay() {
                this.deleteControls = false;
            },

            /** Show the delete controls */
            showDeleteOverlay() {
                this.deleteControls = true;
            },

            /** Delete the device and refresh the data */
            processDelete() {
                this.deleted = true;
                this.deleteDevice(this.deviceKey);
            }
        }
    }
</script>

<style scoped>

</style>